module.exports = __webpack_public_path__ + "public/SiteIcons/address.svg?86b7ac94";